import Swiper from 'swiper'
import 'swiper/swiper-bundle.min.css'

if (!document.querySelector('#carousel-timeline')) {
  return
}

new Swiper('#carousel-timeline', {
  breakpoints: {
    480: {
      slidesPerView: 1,
    },
    640: {
      slidesPerView: 4,
    },
  },
})
